import React from 'react';
import { useTranslation } from 'react-i18next';

import Icon from '../../../../../icons/Icon';
import { ICONS } from '../../../../../icons';

import scss from './NoDataDisclaimer.module.scss';

function NoDataDisclaimer({ title }) {
  const { t } = useTranslation();

  return (
    <div className={scss.wrapper}>
      <Icon icon={ICONS.Unclust} disableCommonStyles currentColor className={scss.emptyIcon} />
      <span>{title || t('noData')}</span>
    </div>
  );
}

export default NoDataDisclaimer;
